const mEditionBillingFiscalAuthorizerConnectAuthorizer = {
  mEditionBillingFiscalAuthorizerConnectAuthorizer: {
    alerts: {
      createAutorizador: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El autorizador fiscal fue conectado exitosamente.'
      }
    },

    buttonPrimary: 'Enviar Solicitud',

    createAutorizador: {
      error: 'Un error ha ocurrido al conectar el autorizador fiscal. Por favor, intenta nuevamente.'
    },

    inputs: {
      descripcion: {
        label: 'Descripción',
        placeholder: 'Descripción'
      }
    },

    redirect: 'Espera un momento, serás redireccionado...',
    title: 'Completa tus datos de',

    validation: {
      required: 'Información requerida.'
    }
  }
}

export default mEditionBillingFiscalAuthorizerConnectAuthorizer
